<template>
  <div
    :class="['loading-state-container', containerClass]"
    :style="{ minHeight }"
  >
    <div class="loading-content">
      <div
        class="loading-spinner"
        :style="{ '--spinner-color': spinnerColor }"
      ></div>
      <div v-if="message" class="loading-text">{{ message }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  /**
   * Loading message to display
   */
  message: {
    type: String,
    default: "",
  },
  /**
   * Color of the loading spinner
   */
  spinnerColor: {
    type: String,
    default: "#003d6a",
  },
  /**
   * Minimum height of the container
   */
  minHeight: {
    type: String,
    default: "400px",
  },
  /**
   * Additional classes for the container
   */
  containerClass: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
.loading-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  text-align: center;
  background: transparent;
  width: 100%;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
  max-width: 300px;
  padding: 20px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f0f0f0;
  border-top: 4px solid var(--spinner-color, #003d6a);
  border-radius: 50%;
  animation: loading-spin 1s linear infinite;
}

.loading-text {
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-medium);
  color: #333;
  font-weight: 500;
  margin: 0;
}

@keyframes loading-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .loading-content {
    padding: 15px;
    gap: 15px;
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border-width: 3px;
  }

  .loading-text {
    font-size: var(--fs-small);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-spinner {
    animation: none;
    border-top-color: transparent;
    border-left-color: var(--spinner-color, #003d6a);
  }
}
</style>
